module.exports = __webpack_public_path__ + "static/kitchen2-d41681584297ea4517b8871106a2cf35.jpg";